export const DONATE_FAQ = [
  {
    q: {
      fr: "Vais-je recevoir un reçu fiscal pour mon don ?",
      en: "Will I receive a tax receipt for my donation?",
    },
    a: {
      fr: "Oui. Pour tout don de 25 $ et plus, un reçu fiscal officiel vous est automatiquement envoyé par courriel en format PDF. La Fondation Enat Espoir & Protection est un organisme de bienfaisance enregistré auprès de l'Agence du revenu du Canada, et votre reçu peut être utilisé dans vos déclarations de revenus fédérale et provinciale.",
      en: "Yes. For any donation of $25 or more, an official tax receipt is automatically emailed to you in PDF format. Fondation Enat Espoir & Protection is a charity registered with the Canada Revenue Agency, and your receipt can be used in your federal and provincial tax returns.",
    },
  },
  {
    q: {
      fr: "Quels modes de paiement acceptez-vous ?",
      en: "What payment methods do you accept?",
    },
    a: {
      fr: "Vous pouvez donner par carte bancaire (Visa, Mastercard, Amex via Stripe) ou avec votre compte PayPal. Tous les paiements sont 100 % sécurisés et vos informations bancaires ne sont jamais conservées sur notre site.",
      en: "You can donate by credit card (Visa, Mastercard, Amex via Stripe) or with your PayPal account. All payments are 100% secure and your banking information is never stored on our website.",
    },
  },
  {
    q: {
      fr: "Comment mon don est-il utilisé ?",
      en: "How is my donation used?",
    },
    a: {
      fr: "Chaque dollar sert directement à aider les femmes et enfants victimes de violence au Québec : hébergement d'urgence, produits de première nécessité, soutien psychosocial et accompagnement vers la reconstruction. Par exemple, 50 $ permettent d'offrir des produits essentiels à une femme à son arrivée en refuge.",
      en: "Every dollar directly helps women and children victims of violence in Quebec: emergency shelter, basic necessities, psychosocial support and rebuilding assistance. For example, $50 provides essential products to a woman arriving at a shelter.",
    },
  },
  {
    q: {
      fr: "Puis-je annuler mon don mensuel ?",
      en: "Can I cancel my monthly donation?",
    },
    a: {
      fr: "Oui, à tout moment et sans frais. Connectez-vous à votre Espace donateur pour gérer vos dons récurrents, ou écrivez-nous à info@fondationenat.org et nous nous en occuperons rapidement.",
      en: "Yes, at any time and free of charge. Log in to your Donor Space to manage your recurring donations, or write to us at info@fondationenat.org and we will take care of it promptly.",
    },
  },
  {
    q: {
      fr: "Puis-je faire un don anonyme ?",
      en: "Can I make an anonymous donation?",
    },
    a: {
      fr: "Absolument. Cochez simplement l'option « Don anonyme » dans le formulaire : votre nom n'apparaîtra jamais publiquement, notamment sur notre Mur d'honneur. Vous recevrez tout de même votre reçu fiscal par courriel.",
      en: "Absolutely. Simply check the 'Anonymous donation' option in the form: your name will never appear publicly, including on our Wall of Honor. You will still receive your tax receipt by email.",
    },
  },
];
